import useCrud from './useCrud';

const listQuery = `
  query($filter: MembershipFilter, $after: Cursor, $first: Int = 20) {
    entities: allMemberships(filter: $filter, after: $after, first: $first) {
      totalCount
      edges {
        cursor
      }
      nodes {
        id
        userId
        address
        phone
        memberCode
        groupCode
        grpUniqueCode
        duration {
          start {
            value
            inclusive
          }
          end {
            value
            inclusive
          }
        }
        user: userByUserId {
          id
          firstName
          lastName
          email
          phone
          address
        }
        group: groupByGroupId {
          id
          name
        }
      }
    }
  }
`;

export default function userMemberships({ client, listPageSize }) {
  return useCrud({
    entityName: 'membership',
    listPageSize,
    listQuery,
    client,
  });
}
